import Vue from "vue";
import Vuex from "vuex";
import pages from "./modules/pages";
import navbar from "./modules/navbar";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    pages,
    navbar
  }
});
